const THEME_STORAGE_KEY = 'useLightTheme'

export const storeTheme = (useLightTheme: boolean): void => {
  // best-effort: localStorage can throw in locked-down contexts
  try {
    localStorage.setItem(THEME_STORAGE_KEY, String(useLightTheme))
  } catch (err) {
    console.warn('Failed to store theme preference in localStorage', err)
  }
}

export const readStoredTheme = (): boolean => {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}
